import type { I18nDict } from '../../../i18n/es';

// Helpers de presentación de la bandeja. Puros, sin React.

/** `5492665012345` → `+54 9 266 501-2345` (AR celular). Otros países: `+<dígitos>`. */
export function formatearTelefono(telefono: string | null): string | null {
  if (!telefono) return null;
  const m = /^549(\d{2,4})(\d{3})(\d{4})$/.exec(telefono);
  if (m) return `+54 9 ${m[1]} ${m[2]}-${m[3]}`;
  return `+${telefono}`;
}

/** Hora relativa corta para la lista ("ahora", "hace 5 min", "ayer"). */
export function tiempoRelativo(iso: string, es: I18nDict, ahora = new Date()): string {
  const t = es.bandeja.tiempo;
  const min = Math.max(0, Math.round((ahora.getTime() - new Date(iso).getTime()) / 60_000));
  if (min < 1) return t.ahora;
  if (min < 60) return t.minutos.replace('{n}', String(min));
  const h = Math.round(min / 60);
  if (h < 24) return t.horas.replace('{n}', String(h));
  const d = Math.round(h / 24);
  if (d === 1) return t.ayer;
  return t.dias.replace('{n}', String(d));
}

/** Hora `HH:mm` local para la burbuja. */
export function horaCorta(iso: string): string {
  return new Date(iso).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
}

/** Separador de día para la conversación. */
export function fechaLarga(iso: string): string {
  return new Date(iso).toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long' });
}

export function mismoDia(a: string, b: string): boolean {
  return new Date(a).toDateString() === new Date(b).toDateString();
}

/** Iniciales para el avatar de la lista. */
export function iniciales(nombre: string | null, telefono: string | null): string {
  if (nombre) {
    const partes = nombre.trim().split(/\s+/).slice(0, 2);
    return partes.map((p) => p[0]?.toUpperCase() ?? '').join('') || '?';
  }
  return telefono ? telefono.slice(-2) : '?';
}
